// import React, { useMemo, useRef } from "react"
// import { AgGridReact } from "ag-grid-react"
// import 'ag-grid-community/styles/ag-grid.css';
// import 'ag-grid-community/styles/ag-theme-material.css';

// const JpmcExpenseTable = (props) => {

//   const gridRef = useRef()
//   const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

//   function getQuarter(month) {
//     if (month >= 4 && month <= 6) return 'APR-JUN';
//     if (month >= 7 && month <= 9) return 'JUL-SEP';
//     if (month >= 10 && month <= 12) return 'OCT-DEC';
//     return 'JAN-MAR';
//   }

//   function combineDataByQuarter(data) {
//     const combined = {};

//     data.forEach(item => {
//       const quarter = getQuarter(item.nMonth);
//       const yearQuarterKey = `${item.nYear}-${quarter}`;

//       if (!combined[yearQuarterKey]) {
//         combined[yearQuarterKey] = {
//           dtAdded_Date: item.dtAdded_Date,
//           dtUpdate_By: item.dtUpdate_By,
//           nYear: item.nYear,
//           quarter: quarter,
//           sContract_Services: 0,
//           sExternal_Evaluation: 0,
//           sMarketing_Promotions_Expenses: 0,
//           sProgram_Expenses: 0,
//           sStaff_Expenses: 0
//         };
//       }

//       combined[yearQuarterKey].sContract_Services += parseInt(item.sContract_Services, 10);
//       combined[yearQuarterKey].sExternal_Evaluation += parseInt(item.sExternal_Evaluation, 10);
//       combined[yearQuarterKey].sMarketing_Promotions_Expenses += parseInt(item.sMarketing_Promotions_Expenses, 10);
//       combined[yearQuarterKey].sProgram_Expenses += parseInt(item.sProgram_Expenses, 10);
//       combined[yearQuarterKey].sStaff_Expenses += parseInt(item.sStaff_Expenses, 10);
//     });

//     return Object.values(combined);
//   }

//   const combinedData = combineDataByQuarter(props.data);

//   function sortCombinedData(combinedData) {
//     const quarterOrder = ['APR-JUN', 'JUL-SEP', 'OCT-DEC', 'JAN-MAR'];

//     return combinedData.sort((a, b) => {
//       if (a.nYear !== b.nYear) {
//         return a.nYear - b.nYear;
//       }
//       return quarterOrder.indexOf(a.quarter) - quarterOrder.indexOf(b.quarter);
//     });
//   }

//   const sortedCombinedData = sortCombinedData(combinedData);

//   const rowDataWithTotal = sortedCombinedData.map(row => ({
//     ...row,
//     totalExpenditure: row.sStaff_Expenses + row.sProgram_Expenses + row.sContract_Services + row.sMarketing_Promotions_Expenses + row.sExternal_Evaluation
//   }));

//   const rowData = rowDataWithTotal

//   const numberFormatter = new Intl.NumberFormat('en-IN');

//   const columnDefs = [
//     {
//       headerName: 'Quarter',
//       field: 'quarter',
//       sortable: true,
//       filter: true,
//       flex: 1,
//       headerComponentFramework: (params) => {
//         return (
//           <div style={{ display: "flex", width: '50px', alignItems: "center" }}>
//             <div>{params.displayName}</div>
//           </div>
//         );
//       },
//     },
//     {
//       headerName: 'Year',
//       field: 'nYear',
//       sortable: true,
//       flex: 1,
//       cellStyle: { textAlign: "right" },
//       headerComponentFramework: (params) => {
//         return (
//           <div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
//             <div>{params.displayName}</div>
//           </div>
//         );
//       },
//     },
//     {
//       headerName: 'Staff Expenses',
//       field: 'sStaff_Expenses',
//       sortable: true,
//       flex: 1,
//       cellStyle: { textAlign: "right" },
//       valueFormatter: params => numberFormatter.format(params.value),
//       headerComponentFramework: (params) => {
//         return (
//           <div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
//             <div>{params.displayName}</div>
//           </div>
//         );
//       },
//     },
//     {
//       headerName: 'Program Expenses',
//       field: 'sProgram_Expenses',
//       sortable: true,
//       flex: 1,
//       cellStyle: { textAlign: "right" },
//       valueFormatter: params => numberFormatter.format(params.value),
//       headerComponentFramework: (params) => {
//         return (
//           <div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
//             <div>{params.displayName}</div>
//           </div>
//         );
//       },
//     },
//     {
//       headerName: 'Contract Services',
//       field: 'sContract_Services',
//       sortable: true,
//       flex: 1,
//       cellStyle: { textAlign: "right" },
//       valueFormatter: params => numberFormatter.format(params.value),
//       headerComponentFramework: (params) => {
//         return (
//           <div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
//             <div>{params.displayName}</div>
//           </div>
//         );
//       },
//     },
//     {
//       headerName: 'Marketing Promotion Expenses',
//       field: 'sMarketing_Promotions_Expenses',
//       sortable: true,
//       flex: 1,
//       cellStyle: { textAlign: "right" },
//       valueFormatter: params => numberFormatter.format(params.value),
//       headerComponentFramework: (params) => {
//         return (
//           <div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center", whiteSpace: 'normal' }}>
//             <div>{params.displayName}</div>
//           </div>
//         );
//       },
//     },
//     {
//       headerName: 'External Evaluation',
//       field: 'sExternal_Evaluation',
//       sortable: true,
//       flex: 1,
//       cellStyle: { textAlign: "right" },
//       cellRenderer: params => {
//         let resourseName = params.value;
//         if (resourseName === "Total") {
//           return <div style={{ textAlign: "right", display: 'none' }}>{resourseName}</div>;
//         } else {
//           return numberFormatter.format(resourseName)
//         }
//       },
//       headerComponentFramework: (params) => {
//         return (
//           <div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
//             <div>{params.displayName}</div>
//           </div>
//         );
//       },
//     },
//     {
//       headerName: 'Total',
//       field: 'totalExpenditure',
//       sortable: true,
//       filter: true,
//       flex: 1,
//       cellStyle: { textAlign: "right" },
//       valueFormatter: params => numberFormatter.format(params.value),
//       headerComponentFramework: (params) => {
//         return (
//           <div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
//             <div>{params.displayName}</div>
//           </div>
//         );
//       },
//     },
//   ];



//   const gridOptions = useMemo(() => ({
//     suppressScrollOnNewData: true,
//   }), []);

//   return (
//     <div>
//       {
//         rowData.length > 0 &&
//         <>
//           <h3 className="spled-colored-label mt-3 mb-3" style={{
//             fontSize: "20px",
//             textAlign: 'center',
//             marginRight: 10
//           }}>Expenses Data</h3>
//           <div style={{
//             height: "50vh",
//           }}>
//             <div style={{ height: "100%", boxSizing: "border-box" }}>
//               <div style={gridStyle} className="ag-theme-material">
//                 <AgGridReact ref={gridRef}
//                   rowData={rowData}
//                   columnDefs={columnDefs}
//                   gridOptions={gridOptions}
//                   overlayNoRowsTemplate={
//                     '<span class="ag-overlay-loading-center">No Records Found</span>'
//                   }
//                 >
//                 </AgGridReact>
//               </div>
//             </div>
//           </div>
//         </>
//       }

//     </div>
//   )
// }

// export default JpmcExpenseTable

import React, { useEffect, useState, useCallback, useMemo, useRef, Children } from "react"
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import arrow_right from "../../assets/ic_header_arrow_right.svg"
import arrow_left from '../../assets/ic_header_arrow_left.svg'

const JpmcExpenseTable = (props) => {
  const gridRef = useRef();
  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: "100%", width: "100%" }), []);

  const getQuarter = (month) => {
      if (month >= 4 && month <= 6) return 'APR-JUN';
      if (month >= 7 && month <= 9) return 'JUL-SEP';
      if (month >= 10 && month <= 12) return 'OCT-DEC';
      return 'JAN-MAR';
  };

  //  function combineDataByQuarter(data) {
  //   const combined = {};
  
  //   data.forEach(item => {
  //     const quarter = getQuarter(item.nMonth);
  //     const yearQuarterKey = `${item.nYear}-${quarter}`;
  
  //     if (!combined[yearQuarterKey]) {
  //       combined[yearQuarterKey] = {
  //         dtAdded_Date: item.dtAdded_Date,
  //         dtUpdate_By: item.dtUpdate_By,
  //         nYear: item.nYear,
  //         quarter: quarter,
  //         sStaff_Expenses: 0,
  //         sPrg_Director: 0,
  //         sPrg_Mngr: 0,
  //         sPrg_Exe: 0,
  //         sProgram_Expenses: 0,
  //         sMobilization_Communication: 0,
  //         sGroup_Knowledge_Session: 0,
  //         sGroup_Expert_Consultation: 0,
  //         sAccess_to_Market: 0,
  //         sAccess_to_Compliance: 0,
  //         sAccess_to_Finance_BLRP: 0,
  //         sTravel_Expenses: 0,
  //         sEquipment_Supplies: 0,
  //         sContract_Services: 0,
  //         sDeAsra_Portal: 0,
  //         sDeAsra_Dashboard_Convenio: 0,
  //         sMarketing_Promotions_Expenses: 0,
  //         sUpgrowth: 0,
  //         sExternal_Evaluation: 0,
  //         sGIPE_CEED_Research_Expense: 0
  //       };
  //     }
  
  //     combined[yearQuarterKey].sStaff_Expenses += parseFloat(item.sStaff_Expenses) || 0;
  //     combined[yearQuarterKey].sPrg_Director += parseFloat(item.sPrg_Director) || 0;
  //     combined[yearQuarterKey].sPrg_Mngr += parseFloat(item.sPrg_Mngr) || 0;
  //     combined[yearQuarterKey].sPrg_Exe += parseFloat(item.sPrg_Exe) || 0;
  //     combined[yearQuarterKey].sProgram_Expenses += parseFloat(item.sProgram_Expenses) || 0;
  //     combined[yearQuarterKey].sMobilization_Communication += parseFloat(item.sMobilization_Communication) || 0;
  //     combined[yearQuarterKey].sGroup_Knowledge_Session += parseFloat(item.sGroup_Knowledge_Session) || 0;
  //     combined[yearQuarterKey].sGroup_Expert_Consultation += parseFloat(item.sGroup_Expert_Consultation) || 0;
  //     combined[yearQuarterKey].sAccess_to_Market += parseFloat(item.sAccess_to_Market) || 0;
  //     combined[yearQuarterKey].sAccess_to_Compliance += parseFloat(item.sAccess_to_Compliance) || 0;
  //     combined[yearQuarterKey].sAccess_to_Finance_BLRP += parseFloat(item.sAccess_to_Finance_BLRP) || 0;
  //     combined[yearQuarterKey].sTravel_Expenses += parseFloat(item.sTravel_Expenses) || 0;
  //     combined[yearQuarterKey].sEquipment_Supplies += parseFloat(item.sEquipment_Supplies) || 0;
  //     combined[yearQuarterKey].sContract_Services += parseFloat(item.sContract_Services) || 0;
  //     combined[yearQuarterKey].sDeAsra_Portal += parseFloat(item.sDeAsra_Portal) || 0;
  //     combined[yearQuarterKey].sDeAsra_Dashboard_Convenio += parseFloat(item.sDeAsra_Dashboard_Convenio) || 0;
  //     combined[yearQuarterKey].sMarketing_Promotions_Expenses += parseFloat(item.sMarketing_Promotions_Expenses) || 0;
  //     combined[yearQuarterKey].sUpgrowth += parseFloat(item.sUpgrowth) || 0;
  //     combined[yearQuarterKey].sExternal_Evaluation += parseFloat(item.sExternal_Evaluation) || 0;
  //     combined[yearQuarterKey].sGIPE_CEED_Research_Expense += parseFloat(item.sGIPE_CEED_Research_Expense) || 0;
  //   });
  
  //   return Object.values(combined);
  // }
  function combineDataByQuarter(data) {
    const combined = {};
  
    data.forEach(item => {
        const quarter = getQuarter(item.nMonth);
        const yearQuarterKey = `${item.nYear}-${quarter}`;
  
        if (!combined[yearQuarterKey]) {
            combined[yearQuarterKey] = {
                dtAdded_Date: item.dtAdded_Date,
                dtUpdate_By: item.dtUpdate_By,
                nYear: item.nYear,
                quarter: quarter,
                sStaff_Expenses: 0,
                sPrg_Director: 0,
                sPrg_Mngr: 0,
                sPrg_Exe: 0,
                sProgram_Expenses: 0,
                sMobilization_Communication: 0,
                sGroup_Knowledge_Session: 0,
                sGroup_Expert_Consultation: 0,
                sAccess_to_Market: 0,
                sAccess_to_Compliance: 0,
                sAccess_to_Finance_BLRP: 0,
                sTravel_Expenses: 0,
                sEquipment_Supplies: 0,
                sContract_Services: 0,
                sDeAsra_Portal: 0,
                sDeAsra_Dashboard_Convenio: 0,
                sMarketing_Promotions_Expenses: 0,
                sUpgrowth: 0,
                sExternal_Evaluation: 0,
                sGIPE_CEED_Research_Expense: 0,
                total: 0  // Initialize total
            };
        }
  
        // Extract and parse the values
        const staffExpenses = parseFloat(item.sStaff_Expenses) || 0;
        const prgDirector = parseFloat(item.sPrg_Director) || 0;
        const prgMngr = parseFloat(item.sPrg_Mngr) || 0;
        const prgExe = parseFloat(item.sPrg_Exe) || 0;
        const programExpenses = parseFloat(item.sProgram_Expenses) || 0;
        const mobilizationCommunication = parseFloat(item.sMobilization_Communication) || 0;
        const groupKnowledgeSession = parseFloat(item.sGroup_Knowledge_Session) || 0;
        const groupExpertConsultation = parseFloat(item.sGroup_Expert_Consultation) || 0;
        const accessToMarket = parseFloat(item.sAccess_to_Market) || 0;
        const accessToCompliance = parseFloat(item.sAccess_to_Compliance) || 0;
        const accessToFinanceBLRP = parseFloat(item.sAccess_to_Finance_BLRP) || 0;
        const travelExpenses = parseFloat(item.sTravel_Expenses) || 0;
        const equipmentSupplies = parseFloat(item.sEquipment_Supplies) || 0;
        const contractServices = parseFloat(item.sContract_Services) || 0;
        const deAsraPortal = parseFloat(item.sDeAsra_Portal) || 0;
        const deAsraDashboardConvenio = parseFloat(item.sDeAsra_Dashboard_Convenio) || 0;
        const marketingPromotionsExpenses = parseFloat(item.sMarketing_Promotions_Expenses) || 0;
        const upgrowth = parseFloat(item.sUpgrowth) || 0;
        const externalEvaluation = parseFloat(item.sExternal_Evaluation) || 0;
        const gipeCEEDResearchExpense = parseFloat(item.sGIPE_CEED_Research_Expense) || 0;
  
        // Update expense categories
        combined[yearQuarterKey].sStaff_Expenses += staffExpenses;
        combined[yearQuarterKey].sPrg_Director += prgDirector;
        combined[yearQuarterKey].sPrg_Mngr += prgMngr;
        combined[yearQuarterKey].sPrg_Exe += prgExe;
        combined[yearQuarterKey].sProgram_Expenses += programExpenses;
        combined[yearQuarterKey].sMobilization_Communication += mobilizationCommunication;
        combined[yearQuarterKey].sGroup_Knowledge_Session += groupKnowledgeSession;
        combined[yearQuarterKey].sGroup_Expert_Consultation += groupExpertConsultation;
        combined[yearQuarterKey].sAccess_to_Market += accessToMarket;
        combined[yearQuarterKey].sAccess_to_Compliance += accessToCompliance;
        combined[yearQuarterKey].sAccess_to_Finance_BLRP += accessToFinanceBLRP;
        combined[yearQuarterKey].sTravel_Expenses += travelExpenses;
        combined[yearQuarterKey].sEquipment_Supplies += equipmentSupplies;
        combined[yearQuarterKey].sContract_Services += contractServices;
        combined[yearQuarterKey].sDeAsra_Portal += deAsraPortal;
        combined[yearQuarterKey].sDeAsra_Dashboard_Convenio += deAsraDashboardConvenio;
        combined[yearQuarterKey].sMarketing_Promotions_Expenses += marketingPromotionsExpenses;
        combined[yearQuarterKey].sUpgrowth += upgrowth;
        combined[yearQuarterKey].sExternal_Evaluation += externalEvaluation;
        combined[yearQuarterKey].sGIPE_CEED_Research_Expense += gipeCEEDResearchExpense;
  
        // Update total directly
        combined[yearQuarterKey].total += staffExpenses +
                                         prgDirector +
                                         prgMngr +
                                         prgExe +
                                         programExpenses +
                                         mobilizationCommunication +
                                         groupKnowledgeSession +
                                         groupExpertConsultation +
                                         accessToMarket +
                                         accessToCompliance +
                                         accessToFinanceBLRP +
                                         travelExpenses +
                                         equipmentSupplies +
                                         contractServices +
                                         deAsraPortal +
                                         deAsraDashboardConvenio +
                                         marketingPromotionsExpenses +
                                         upgrowth +
                                         externalEvaluation +
                                         gipeCEEDResearchExpense;
    });
  
    return Object.values(combined);
}

  function sortCombinedData(combinedData) {
    const quarterOrder = ['JAN-MAR' ,'APR-JUN', 'JUL-SEP', 'OCT-DEC']; 
  
    return combinedData.sort((a, b) => {
      if (a.nYear !== b.nYear) {
        return a.nYear - b.nYear;
      }
      return quarterOrder.indexOf(a.quarter) - quarterOrder.indexOf(b.quarter);
    });
  }

  const pivotData = (data) => {
      const expenses = [
          'sPrg_Director', 'sPrg_Mngr', 'sPrg_Exe', 'sMobilization_Communication', 'sGroup_Knowledge_Session', 'sGroup_Expert_Consultation', 
          'sAccess_to_Market', 'sAccess_to_Compliance', 'sAccess_to_Finance_BLRP', 'sTravel_Expenses', 'sEquipment_Supplies', 
          'sDeAsra_Portal', 'sDeAsra_Dashboard_Convenio', 'sUpgrowth', 'sGIPE_CEED_Research_Expense'
      ];

      const pivotedData = {};

      expenses.forEach(expense => {
          pivotedData[expense] = { expense: expense };
      });

      data.forEach(row => {
          const quarterYear = `${row.quarter} ${row.nYear}`;
          expenses.forEach(expense => {
              if (!pivotedData[expense][quarterYear]) {
                  pivotedData[expense][quarterYear] = 0;
              }
              pivotedData[expense][quarterYear] += row[expense] || 0;
          });
      });

      return Object.values(pivotedData);
  };

  const combinedData = combineDataByQuarter(props.data);
  const sortedCombinedData = sortCombinedData(combinedData);
  const pivotedData = pivotData(sortedCombinedData);

  console.log("Data", sortedCombinedData)

  const numberFormatter = new Intl.NumberFormat('en-IN');

const CustomCellRenderer = (props) => {
    let resourceName = props.value;
    if (resourceName !== undefined) {
      resourceName = numberFormatter.format(props.value);
    } else{
      resourceName = '$0'
    }
    if (resourceName === "Total") {
      return <div style={{ textAlign: "right", display: "none" }}>{resourceName}</div>;
    } else {
      return <div>{resourceName}</div>;
    }
  };

  const calculateFooterRow = (data) => {
    // Initialize footerRow with expense label
    const footerRow = { expense: "Total" };

    // Map each quarter-year header to its corresponding total value
    data.forEach(row => {
        const quarterYear = `${row.quarter} ${row.nYear}`;
        footerRow[quarterYear] = row.total || 0; // Use total from sortedCombinedData
    });

    return footerRow;
};

const footerRow = calculateFooterRow(sortedCombinedData);

console.log("footer", footerRow)

const rowSpan = (params) => {
  var athlete = params.data ? params.data.expense : undefined;
  console.log("Param", params.data)
  if (athlete === "sPrg_Director") {
    // have all Russia age columns width 2
    return 3;
  } else if (athlete === "sMobilization_Communication") {
    // have all United States column width 4
    return 8;
  } else if (athlete === "sDeAsra_Portal") {
    // have all United States column width 4
    return 2;
  } else if (athlete === "sUpgrowth") {
    // have all United States column width 4
    return 1;
  } else if (athlete === "sGIPE_CEED_Research_Expense") {
    // have all United States column width 4
    return 1;
  } else {
    // all other rows should be just normal
    return 1;
  }
};

const CustomBoldTextRenderer = (props) => {
  // Check if the row is pinned
  if (props.node.rowPinned) {
    return '';  // Return empty or some default value for pinned rows
  }

  // Define the mapping for row types
  const typeMapping = {
    0: 'Staff Expenses',
    3: 'Program Expenses',
    11: 'Contract Services',
    13: 'Marketing and Promotion Expenses',
    14: 'External Evaluation'
  };

  // Get the type based on the rowIndex
  const type = typeMapping[props.node.rowIndex] || '';

  // Render the type with bold styling
  return (
    <div style={{ fontWeight: 'bold' }}>
      {type}
    </div>
  );
};



  // const columnDefs = [
  //   {
  //     headerName: 'Type',
  //     field: 'type',
  //     pinned: 'left',
  //     width: 270,
  //     rowSpan: rowSpan,
  //     cellClass: (params) => {
  //       // Assign CSS classes based on data or other conditions
  //       if (params.data && params.data.expense === 'sPrg_Director') {
  //         return 'cell-span-odd'; // Apply class for specific condition
  //       }
  //       if (params.data && params.data.expense === 'sMobilization_Communication') {
  //         return 'cell-span-even'; // Apply class for different condition
  //       }

  //       if (params.data && params.data.expense === 'sDeAsra_Portal') {
  //         return 'cell-span-odd'; // Apply class for different condition
  //       }

  //       if (params.data && params.data.expense === 'sUpgrowth') {
  //         return 'cell-span-no-border-even'; // Apply class for different condition
  //       }
  //       if (params.data && params.data.expense === 'sGIPE_CEED_Research_Expense') {
  //         return 'cell-span-no-border-odd'; // Apply class for different condition
  //       }
  //       return null; // Default class
  //     },
  //     cellRendererFramework: CustomBoldTextRenderer,
  //     // cellRenderer: (params) => {
  //     //     if (params.node.rowPinned) {
  //     //         return '';  // Leave the footer row empty
  //     //     }
  //     //     const typeMapping = {
  //     //         0: 'Staff Expenses',
  //     //         // 1: 'Staff Expenses',
  //     //         // 2: 'Staff Expenses',
  //     //         3: 'Program Expenses',
  //     //         // 4: 'Program Expenses',
  //     //         // 5: 'Program Expenses',
  //     //         // 6: 'Program Expenses',
  //     //         // 7: 'Program Expenses',
  //     //         // 8: 'Program Expenses',
  //     //         // 9: 'Program Expenses',
  //     //         // 10: 'Program Expenses',
  //     //         11: 'Contract Services',
  //     //         // 12: 'Contract Services',
  //     //         13: 'Marketing and Promotion Expenses',
  //     //         14: 'External Evaluation'
  //     //     };
  //     //     return typeMapping[params.node.rowIndex] || '';
  //     // },
      
  // },
  //     {
  //         headerName: 'Expenses',
  //         field: 'expense',
  //         pinned: 'left',
  //         width: 300,
  //         cellRenderer: (params) => {
  //             const expenseMapping = {
  //                 sPrg_Director: "Program Director",
  //                 sPrg_Mngr: "Program Manager",
  //                 sPrg_Exe: "Program Executive",
  //                 sMobilization_Communication: "Mobilization and Communication",
  //                 sGroup_Knowledge_Session: "Group Knowledge Session",
  //                 sGroup_Expert_Consultation: "Group Expert Consultation",
  //                 sAccess_to_Market: "Access to Market",
  //                 sAccess_to_Compliance: "Access to Compliance",
  //                 sAccess_to_Finance_BLRP: "Access to Finance - BLRP",
  //                 sTravel_Expenses: "Travel Expenses",
  //                 sEquipment_Supplies: "Equipment and Supplies",
  //                 sDeAsra_Portal: "deAsra Portal",
  //                 sDeAsra_Dashboard_Convenio: "deAsra Dashboard - Convenio",
  //                 sUpgrowth: "Upgrowth",
  //                 sGIPE_CEED_Research_Expense: "GIPE CEED Research Expense"
  //             };
  //             return expenseMapping[params.value] || params.value;
  //         }
  //     },
  //     ...sortedCombinedData.reduce((acc, row) => {
  //         const quarterYear = `${row.quarter} ${row.nYear}`;
  //         if (!acc.some(col => col.headerName === quarterYear)) {
  //             acc.push({
  //                 headerName: quarterYear,
  //                 field: quarterYear,
  //                 headerComponentFramework: (params) => {
  //                             return (
  //                                 <div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center" }}>
  //                                     <div>{params.displayName} (₹)</div>
  //                                 </div>
  //                             );
  //                         },
  //                 cellRendererFramework:CustomCellRenderer,
  //                 width: 200,
  //                 cellStyle: { textAlign: "right" },
  //                 // valueFormatter: params => params.value !== undefined ? numberFormatter.format(params.value) : '$0',
  //             });
  //         }
  //         return acc;
  //     }, [])
  // ];

  const [visibleColumns, setVisibleColumns] = useState({ start: 0, end: 5 });

  const handleNext = () => {
    console.log("Vis", visibleColumns)
    setVisibleColumns(prev => ({ start: prev.start + 5, end: prev.end + 5 }));
  };

  const handlePrevious = () => {
    setVisibleColumns(prev => ({ start: prev.start - 5, end: prev.end - 5 }));
  };

  const getVisibleColumns = () => {
    const columnDefs = [
      {
        headerName: 'Type',
        field: 'type',
        pinned: 'left',
        width: 270,
        headerComponentFramework: (params) => {
          return (
            <div style={{ display: "flex", width: '100%', alignItems: "center", paddingBottom: '13px' }}>
              <div>{params.displayName}</div>
            </div>
          );
        },
        rowSpan: rowSpan,
        cellClass: (params) => {
          if (params.data && params.data.expense === 'sPrg_Director') {
            return 'cell-span-odd';
          }
          if (params.data && params.data.expense === 'sMobilization_Communication') {
            return 'cell-span-even';
          }
          if (params.data && params.data.expense === 'sDeAsra_Portal') {
            return 'cell-span-odd';
          }
          if (params.data && params.data.expense === 'sUpgrowth') {
            return 'cell-span-no-border-even';
          }
          if (params.data && params.data.expense === 'sGIPE_CEED_Research_Expense') {
            return 'cell-span-no-border-odd';
          }
          return null;
        },
        cellRendererFramework: CustomBoldTextRenderer,
      },
      {
        headerName: 'Expenses',
        field: 'expense',
        pinned: 'left',
        width: 300,
        headerComponentFramework: (params) => {
          return (
            <div style={{ display: "flex", width: '100%', alignItems: "center", paddingBottom: '13px' }}>
              <div>{params.displayName}</div>
            </div>
          );
        },
        cellRenderer: (params) => {
          const expenseMapping = {
            sPrg_Director: "Program Director",
            sPrg_Mngr: "Program Manager",
            sPrg_Exe: "Program Executive",
            sMobilization_Communication: "Mobilization and Communication",
            sGroup_Knowledge_Session: "Group Knowledge Session",
            sGroup_Expert_Consultation: "Group Expert Consultation",
            sAccess_to_Market: "Access to Market",
            sAccess_to_Compliance: "Access to Compliance",
            sAccess_to_Finance_BLRP: "Access to Finance - BLRP",
            sTravel_Expenses: "Travel Expenses",
            sEquipment_Supplies: "Equipment and Supplies",
            sDeAsra_Portal: "deAsra Portal",
            sDeAsra_Dashboard_Convenio: "deAsra Dashboard - Convenio",
            sUpgrowth: "Upgrowth",
            sGIPE_CEED_Research_Expense: "GIPE CEED Research Expense"
          };
          return expenseMapping[params.value] || params.value;
        }
      }
    ];

    const dynamicColumns = sortedCombinedData.reduce((acc, row, index) => {
      if (index >= visibleColumns.start && index < visibleColumns.end) {
        const quarterYear = `${row.quarter} ${row.nYear}`;
        if (!acc.some(col => col.headerName === quarterYear)) {
          acc.push({
            headerName: quarterYear,
            field: quarterYear,
            headerComponentFramework: (params) => {
              return (
                <div style={{ display: "flex", justifyContent: 'center', width: '100%', alignItems: "center", paddingBottom: '13px' }}>
                  <div>{params.displayName} (₹)</div>
                </div>
              );
            },
            cellRendererFramework: CustomCellRenderer,
            // width: 200,
            flex:1,
            cellStyle: { textAlign: "right" },
          });
        }
      }
      return acc;
    }, []);

    // const actionColumn = {
    //   headerName: (
    //     <div>
    //       {visibleColumns.start > 0 && <button onClick={handlePrevious}>Previous</button>}
    //       <button onClick={handleNext}>Next</button>
    //     </div>
    //   ),
    //   field: 'action',
    //   width: 200,
    // };

    return [...columnDefs, ...dynamicColumns];
  };

  const gridOptions = {
    suppressRowTransform:true
};
  

  // const footerRow = {
  //   expense: "Total",
    
  //   first_time_data: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.first_time_data, 0),
  //   engaged_count: "Total" + " : " + " " + rowData.reduce((total, row) => total + row.engaged_count, 0),
  // };

  return (
    <div>
      {
        pivotData.length > 0 &&
<>
        {/* <h3 className="spled-colored-label mt-3 mb-3" style={{
          fontSize: "20px",
          textAlign: 'center',
          marginRight: 10
        }}>Expenses Data</h3> */}
          <div>
            {visibleColumns.start > 0 && <img
              style={{
                position: 'absolute',
                top: 83,
                right: 70,
                zIndex: 1,
                cursor: 'pointer'
              }}
              alt=""
              src={arrow_left}
              height={"17px"}
              width={"17px"}
              className=""
              onClick={handlePrevious}
            />}
            {visibleColumns.end < sortedCombinedData.length && <img
              style={{
                position: 'absolute',
                top: 83,
                right: 40,
                zIndex: 1,
                cursor: 'pointer'
              }}
              alt=""
              src={arrow_right}
              height={"17px"}
              width={"17px"}
              className=""
              onClick={handleNext}
            />}

            {/* <button onClick={handleNext}>Next</button> */}
          </div>
      <div style={{
        height: "80vh",
      }}>
        <div style={{ height: "100%", boxSizing: "border-box" }}>
          <div style={gridStyle} className="ag-theme-material">
            {/* <AgGridReact ref={gridRef}
              rowData={rowData}
              columnDefs={columnDefs}
              // pinnedBottomRowData={[footerRow]}
              gridOptions={gridOptions}
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">No Records Found</span>'
              }
              // rowClassRules={{
              //   'total-row': 'data.sBusinessSector === "Total"'
              // }}
            >
            </AgGridReact> */}
            <AgGridReact
                    ref={gridRef}
                    rowData={pivotedData}
                    columnDefs={getVisibleColumns()}
                    pinnedBottomRowData={[footerRow]}
                    // defaultColDef={{
                    //     resizable: true,
                    //     sortable: true,
                    //     filter: true,
                    // }}
                    gridOptions={gridOptions}
              overlayNoRowsTemplate={
                '<span class="ag-overlay-loading-center">No Records Found</span>'
              }
              rowClassRules={{
                'total-row': 'data.expense === "Total"'
              }}
                />
          </div>
        </div>
      </div>
      </>
      }
    
    </div>
  )
}

export default JpmcExpenseTable
